<template>
  <div class="q1" :class="{ fade: fade }">
    <div class="content">
      <AppBar></AppBar>
      <img
        class="q-index"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q1-head"
      />
      <div class="q-title animate__animated animate__fadeInDown">你的性别</div>
      <div class="q-box">
        <div class="gender-list">
          <div
            class="gender-item"
            :class="{ 'gender-item-active': curGender == index }"
            v-for="(item, index) in genderList"
            :key="index"
            @click.stop="bindChange(index)"
          >
            <img class="gender-image" :src="item.url" alt="" />
            <div class="gender-text">我是{{ item.value }}</div>
          </div>
        </div>
      </div>
      <div class="q-next" v-if="data[index].value !== ''" @click="bindNext"
        >下一步</div
      >
    </div>
  </div>
</template>
<script>
import QBtn from './q-btn.vue'
import AppBar from '../app-bar.vue'
export default {
  components: {
    QBtn,
    AppBar
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      curGender: -1,
      fade: false,
      disabled: false,
      genderList: [
        {
          key: 'a',
          value: '男生',
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q1-boy'
        },
        {
          key: 'b',
          value: '女生',
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q1-girl'
        }
      ]
    }
  },
  created() {
    this.updateGender()
    this.$buryPoint('BG_XRWJ_WT1', {})
  },
  methods: {
    updateGender() {
      let curGender = -1
      let value = this.data[this.index].value
      this.genderList.map((item, index) => {
        if (item.key == value) {
          curGender = index
        }
      })
      this.curGender = curGender
    },
    bindChange(index) {
      this.curGender = index
      this.data[this.index].value = this.genderList[index].key
    },
    bindNext() {
      if (this.disabled) {
        return
      }
      this.disabled = true
      this.fade = true
      setTimeout(() => {
        this.$emit('next')
      }, 500)
    }
  }
}
</script>
<style lang="scss" scoped>
.q1 {
  opacity: 1;
  transition: opacity 0.5s linear;
  position: relative;
  overflow-y: scroll;
  width: 100%;
  min-height: 100vh;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q1-bg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  .content {
    overflow: hidden;
  }
  .q-index {
    width: 328px;
    margin: 7px auto 13px;
    height: 61px;
  }
  .q-title {
    text-align: center;
    font-size: 24px;
    font-family: MaoKenTangYuan-beta, MaoKenTangYuan;
    font-weight: 600;
    color: #000000;
    line-height: 34px;
    margin-bottom: 49px;
  }
  .q-box {
    .gender-list {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 88px;
      .gender-item {
        width: 119px;
        height: 345px;
        object-fit: contain;
        margin-right: 48px;
        .gender-image {
          transform: scale(0.95);
          transform-origin: center bottom;
          opacity: 0.26;
          width: 100%;
          margin-bottom: 20px;
          transition: transform 0.3s ease;
        }
        .gender-text {
          text-align: center;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.36);
          line-height: 24px;
        }
      }
      .gender-item:last-child {
        margin-right: 0px;
      }
      .gender-item-active {
        .gender-image {
          opacity: 1;
          transform: scale(1);
        }
        .gender-text {
          color: rgba(0, 0, 0, 0.9);
          font-weight: 600;
        }
      }
    }
  }
  .q-next {
    margin: 0 auto 57px;
    text-align: center;
    line-height: 40px;
    font-weight: 600;
    width: 274px;
    height: 42px;
    box-sizing: border-box;
    border-radius: 22px;
    border: 2px solid rgba(0, 0, 0, 0.9);
  }
}
.fade {
  opacity: 0;
}
@keyframes myrotate {
  0% {
    transform: translateY(100px);
  }
  100% {
    transform: translateY(0px);
  }
}
</style>
